import { defineStore } from 'pinia';

export const useTelegramPopupStore = defineStore('telegramPopup', () => {
  const isHidden = ref(false);
  return {
    isHidden,
  };
});
